import React, {useState} from "react";
import Button from "react-bootstrap/es/Button";
import {Col, Row} from "react-bootstrap";
import { InputWithLabel } from "../../component/Form/InputWithLabel";
import Notify from "../../services/Notify";
import ModalMessageNew from "../../component/Modal/ModalMessageNew";
import ReadpointService from "../../services/ReadpointService";

class GridReadpoints {
  title = "Lista de Pontos de leituras";
  actionsButtons = (row, reloadGrid) => {
    const [show, setShow] = useState(false);
    const deleteItem = async () => {
      try {
        await new ReadpointService().deleteReadPointById(row.original.id);
        Notify.success('Ponto de leitura deletado com sucesso!');
      } catch (error) {
        Notify.error('Erro ao excluir ponto de leitura', error);
      } finally {
        setShow(false);
        reloadGrid && reloadGrid();
      }
    };
    return (
        <Row>
            <Col lg={6}>
                <Button bsStyle="primary" block href={`#/readpoints/${row.original.id}/antennas`}>Antenas</Button>
            </Col>
            <Col lg={6}>
                <Button bsStyle="success" block href={`#/readpoints/${row.original.id}/edit`}>Editar</Button>
            </Col>
            <Col lg={6} className="mt-3">
                <Button bsStyle="info" block href={`#/automatic/portals/${row.original.id}`}>Configuração do Ponto de Controle</Button>
            </Col>
            <Col lg={6} className="mt-3">
                <Button style={{backgroundColor: '#00EBDD', color: 'white'}} block href={`#/readpoints/portals/${row.original.id}/users`}>Usuários</Button>
            </Col>
            <Col lg={6} className="mt-3">
                <Button bsStyle="danger" block onClick={() => setShow(true)}>Excluir</Button>
            </Col>
            <ModalMessageNew
                row={row}
                showModal={show}
                handleShowModal={setShow}
                title="Tem certeza que deseja excluir o ponto de leitura?"
                successButtonAction={deleteItem}
            />
        </Row>
    );
  };
  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName",
      HeaderColumn: true
    },
    {
      Header: "Tipo",
      accessor: "type"
      , Cell: row => {
        switch (row.original.type) {
          case "COMMISSIONER":
            return "Comissionador";
          case "MOVEL":
            return "Móvel";
          case "NODE":
            return "Node";
          case "STEREO":
            return "Stéreo";
          default:
            return row.original.type;
        }
      }

    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => this.actionsButtons(row, this.forceReload)
    }
  ];

  customFilters = { friendlyName: null }

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={6}>
          <InputWithLabel label="Nome" onChangeWithDelay={e => {
            this.customFilters.friendlyName = e.trim()
            onChange(this.customFilters)
          }}/>
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const { friendlyName } = this.customFilters

    friendlyName && params.append('friendlyName', friendlyName)

    return `cloud/v1/readpoints?${params.toString()}`
  }
}

export default GridReadpoints;



// WEBPACK FOOTER //
// ./src/readpoint/component/ReadpointGrid.js